module.exports = __webpack_public_path__ + "img/accept.b9bd583c.svg";